export enum QUERY_KEYS {
  DOCUMENT_VERSIONS = 'DOCUMENT_VERSIONS',
  DOCUMENT_VERSION = 'DOCUMENT_VERSION',
}

export default QUERY_KEYS
